import { z } from "zod";

export const ProfileSchema = z.object({
  id: z.string(),
  // Depuis la migration 126, `get_profiles_for_role` ne renvoie l'email qu'à
  // admin/c_level — les autres rôles reçoivent une projection minimale sans
  // cette clé (fuite de PII corrigée, audit 2026-09-10 §3). `.default("")`
  // plutôt que `.optional()` : garde le type `string` partout où l'appelant
  // fait déjà `nom || email` en fallback d'affichage (≈20 sites), sans les
  // toucher un par un — une chaîne vide y produit exactement le même résultat
  // qu'un `undefined` (fallback suivant, ou rien).
  email: z.string().default(""),
  first_name: z.string().nullable().optional(),
  last_name: z.string().nullable().optional(),
  role: z.string(),
  telephone: z.string().nullable().optional(),
  societe: z.string().nullable().optional(),
  specialites: z.array(z.string()).nullable().optional(),
  statut: z.enum(["actif", "inactif"]).nullable().optional(),
  lang: z.string().nullable().optional(),
  created_at: z.string().nullable().optional(),
  updated_at: z.string().nullable().optional(),
});
export type ProfileRow = z.infer<typeof ProfileSchema>;

export const ProfileUpdateSchema = ProfileSchema
  .omit({ id: true, email: true, created_at: true, updated_at: true })
  .partial();
export type ProfileUpdate = z.infer<typeof ProfileUpdateSchema>;
